app.controller('DataApiPageController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    let dataApiID;
    let dataTypeID;
    let categorySlug;
    let postSlug;

    $scope.data_api_params = {};

    function checkParams() {
        dataApiID = $scope.data_api_id ? $scope.data_api_id : ($state.$current && $state.$current.data ? $state.$current.data.data_api_id : null);
        categorySlug = $scope.category_slug ? $scope.category_slug : $stateParams.category_slug;
        postSlug = $scope.post_slug ? $scope.post_slug : $stateParams.post_slug;
        if (dataApiID === $scope.data_api_params.data_api_id && categorySlug === $scope.data_api_params.category_slug && postSlug === $scope.data_api_params.post_slug) {
            return true;
        }
        $scope.data_api_params.data_api_id = dataApiID;
        $scope.data_api_params.category_slug = categorySlug;
        $scope.data_api_params.post_slug = postSlug;
        if (postSlug) {
            dataTypeID = "post";
        } else if (categorySlug) {
            dataTypeID = "category";
        } else {
            dataTypeID = "overview";
        }
        $scope.data_api_params.data_type_id = dataTypeID;
        return false;
    }

    checkParams();

    $scope.breadcrumbs = [];


    const dataApiService = $rootScope.service.data_api;

    const data_api_model = dataApiService.factory.getModel({data_api_id: dataApiID});

    $scope.isValidDataAPI = function () {
        return !!data_api_model.post_type;
    }

    $scope.currentCategory = function () {
        return categorySlug ? data_api_model.categories[categorySlug] : null;
    }
    $scope.currentPost = function () {
        return postSlug ? data_api_model.posts[postSlug] : null;
    }

    $scope.currentTitle = function () {
        switch (dataTypeID) {
            case "overview":
                return data_api_model.overview_name;
            case "category":
                const category = $scope.currentCategory();
                return category ? category.name : null;
            case "post":
                const post = $scope.currentPost();
                if (post) {
                    if (post.name) {
                        return post.name
                    }
                    if (post.title && post.title.rendered) {
                        return post.title.rendered
                    }
                }
                return null;
            default:
                return null;
        }
    }

    $scope.currentPostDate = function () {
        if (dataTypeID === "post") {
            const post = $scope.currentPost();
            return post ? post.readable_date : null;
        }
        return null;
    }

    $scope.hasFeaturedImage = function () {
        const currentPost = $scope.currentPost();
        return currentPost && currentPost.featured_image_options && currentPost.featured_image_options.full;
    }

    function updateBreadcrumbs() {
        let currentCategory;

        $scope.breadcrumbs = [
            {
                name: "Home",
                href: "/"
            }
        ];

        const overviewBreadcrumb = {
            name: data_api_model.overview_name,
            href: null
        }

        $scope.breadcrumbs.push(overviewBreadcrumb);

        if (dataTypeID === "overview") {
            return;
        }
        overviewBreadcrumb.href = data_api_model.home_sref ? $state.href(data_api_model.home_sref) : null;

        let currentName = "";
        if (dataTypeID === 'category') {
            currentCategory = $scope.currentCategory();
            currentName = currentCategory ? currentCategory.name : "";
        } else if (dataTypeID === 'post') {
            const currentPost = $scope.currentPost();
            if (currentPost && currentPost.category_list && currentPost.category_list.length > 0) {
                currentCategory = currentPost.category_list[0];
                if (!currentCategory.is_default) {
                    $scope.breadcrumbs.push({
                        href: currentCategory.href,
                        name: currentCategory.name
                    });
                }
            }
            currentName = currentPost && currentPost.title ? currentPost.title.rendered : "";
        }
        $scope.breadcrumbs.push({
            name: currentName
        });
    }


    updateBreadcrumbs();

    const unbindStateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function ($event, next, current) {
        if (!checkParams()) {
            updateBreadcrumbs();
        }
    });

    const unbindDataApiUpdate = $scope.$on('data_api_update', function ($event, params) {
        if (params && params.data_api_id === dataApiID) {
            updateBreadcrumbs();
        }
    });

    $scope.getPostSourceURL = function (post) {
        if(post.attachment_meta && post.attachment_meta.source_url){
            let sourceURL = post.attachment_meta.source_url;
            return sourceURL + (sourceURL.includes("?") ? "&" : "?") + "user_id="
        }
        return post.source_url;
    }


    $scope.$on('$destroy', unbindStateChangeSuccess);
    $scope.$on('$destroy', unbindDataApiUpdate);


}])